import React from "react";
import { isActiveStaff } from "./staffActive";

// Muted "Archived" pill for staff who have left (FlagActive != 1). Render it
// next to a staff name on DISPLAY / history screens so leavers stay visible
// (their row is kept for history) but are clearly flagged as no longer current.
// Renders nothing for active staff. See STAFF_LEAVER_HIDE_PLAN.md.
export default function StaffArchivedBadge({ staff, className = "" }) {
  if (!staff || isActiveStaff(staff)) return null;
  return (
    <span
      className={`badge bg-secondary-subtle text-secondary ms-2 ${className}`}
      title="This staff member has left"
    >
      Archived
    </span>
  );
}
